export function enableSmoothScroll() {
const root = document.documentElement;
const prev = root.style.scrollBehavior;
root.style.scrollBehavior = "smooth";
return () => { root.style.scrollBehavior = prev; };
}